export const BASE_URL = "https://api.shop-dr-evol.ie";
